import { nodeListToArray } from "./dom-utils.js";
import { listenAll, dispatchCentral, listenCentral } from './events.js'


function checkInputSaturation(prevInputsSaturated, input) {
    const minLength = parseInt(input.dataset.minLength)
    if (!prevInputsSaturated || isNaN(minLength)) {
        return prevInputsSaturated;
    }
    return minLength <= input.value.length
}

function checkAllSaturated(formInputs) {
    return nodeListToArray(formInputs).reduce(checkInputSaturation, true)
}

function markFormSaturated() {
    const formEL = document.querySelector('form')
    if (!formEL) { return }
    formEL.classList.add('g-saturated')
}

function markFormDesaturated() {
    const formEL = document.querySelector('form')
    if (!formEL) { return }
    formEL.classList.remove('g-saturated')
}

function markInputSaturated(evt) {
    evt.target.classList.add('g-saturated')
}

function markInputDesaturated(evt) {
    evt.target.classList.remove('g-saturated')
}

function logall(formInputs) {
    listenAll('input paste keydown keypress click', formInputs, (e) => {
        console.debug('logall : ', e.type, e.target)
    })
}

export function monitorFormInputs() {
    const formInputs = document.querySelectorAll('form input[data-min-length][required]')
    if (!formInputs) { return; }
    logall(formInputs)
    listenAll('input-synth', formInputs, (e) => {
        checkInputSaturation(true, e.target)
    })
    listenAll('input', formInputs, (e) => {
        if (checkInputSaturation(true, e.target)) {
            dispatchCentral('input-saturated', { target: e.target })
        } else {
            dispatchCentral('input-desaturated', { target: e.target })
        }
        if (checkAllSaturated(formInputs)) {
            dispatchCentral('all-saturated')
        } else {
            dispatchCentral('all-desaturated')
        }
    })

    listenCentral('all-saturated', markFormSaturated)
    listenCentral('all-desaturated', markFormDesaturated)
    listenCentral('input-saturated', markInputSaturated)
    listenCentral('input-desaturated', markInputDesaturated)
}
